import React, { useState, useEffect, useMemo, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import ReactSelect from "react-select";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { fireStore } from "../../../../Firebase/config";
import { useDispatch, useSelector } from "react-redux";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import CustomReactQuill from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import { GetCountry } from "../../../../redux/master/action";
import { getIndustry } from "../../../../redux/categary/action";
import { addMerger, updateMerger } from "../../../../redux/mergers/action";
import { urlValidation } from "../../../../CloudStorage/CommonFunction";
import CompanyFileUpload from "../../ExpertCompanyRegistration/DifferentFlow/CompanyFlow/CompanyFileUpload";
import { descriptionvalidation, filesvalidationforstatusbase, nospecialtitle, titlevalidation } from "../../../Common/commonvalidation";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import CoverImages from "../../../Common/CoverImages";

const bxpDatatomap = [
  { title: (<>Company name <AsteriskLabel /></>), name: "company_name", placeholder: "Company Name" },
  { title: (<>Company logo </>), name: "logo", placeholder: "Upload logo" },
  {
    title: (<>Company industry <AsteriskLabel /></>),
    name: "industry_id",
    placeholder: "Select An Option",
  },
  { title: (<>Company website <AsteriskLabel /></>), name: "website_link", placeholder: "Enter URL" },
  { title: (<>Company location <AsteriskLabel /></>), name: "address", placeholder: "Enter address" },
  { title: (<>Pin Code <AsteriskLabel /></>), name: "pincode", placeholder: "Enter pincode" },
  { title: (<>City <AsteriskLabel /></>), name: "city", placeholder: "Enter city" },
  { title: (<>Country <AsteriskLabel /></>), name: "country_id", placeholder: "Select country" },
  {
    title: (<>Description <AsteriskLabel /></>),
    name: "description",
    placeholder: "Description",
  },
  { title: (<>Company profile <AsteriskLabel /></>), name: "files", placeholder: "Upload image" },
];

const SyncParent = ({ values, setbxpData, updateindex, initialValues, setChangesIsThere }) => {
  const lastSynced = useRef("");
  const initialSnapshot = useRef(null);

  if (initialSnapshot.current === null) {
    initialSnapshot.current = JSON.stringify(initialValues);
  }

  useEffect(() => {
    const currentValues = JSON.stringify(values);
    if (lastSynced.current !== currentValues) {
      if (updateindex === null && Object.keys(values).length > 0) {
        setbxpData((prev) => ({ ...prev, ...values }));
      }
      const hasChanges = currentValues !== initialSnapshot.current;
      setChangesIsThere(hasChanges);
      lastSynced.current = currentValues;
    }
  }, [values, updateindex, setbxpData, setChangesIsThere]);
  return null;
};

const BXPDetails = ({ updateindex, bxpData, setbxpData, setModalOpen, setModal, setChangesIsThere }) => {
  const [selectIndustry, setSelectIndustry] = useState(null);
  const [selectCountry, setSelectCountry] = useState(null);
  const [loading, setLoading] = useState(false);
  const [logoImage, setLogoImage] = useState(null);
  const [profileImage, setProfileImage] = useState(null);

  const countrylist = useSelector(({ master: { countrylist } }) => countrylist) || [];
  const industrylist = useSelector(({ categary: { industrylist } }) => industrylist) || [];
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    company_name: nospecialtitle,
    logo: logoImage
      ? ""
      : Yup.string()
        .trim()
        .required("This Field is Required")
        .test(
          "not-only-spaces",
          "Please enter a valid value",
          (value) => value.trim() !== ""
        ),
    industry_id: Yup.string().required("Industry is required"),
    website_link: Yup.string()
      .required("URL is required")
      .test("valid-url", "Enter a valid URL", (value) => urlValidation(value)),
    address: Yup.string()
      .trim()
      .required("This Field is Required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    pincode: Yup.string().required("Pin Code is required"),
    city: Yup.string()
      .trim()
      .required("This Field is Required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    country_id: Yup.string().required("Country is required"),
    description: descriptionvalidation,
    files: filesvalidationforstatusbase,
  });

  useEffect(() => {
    if (updateindex) {
      setLogoImage(null);
      setProfileImage(null);
    }
  }, [updateindex]);

  const initialValues = useMemo(() => {
    return {
      company_name: bxpData?.company_name || "",
      logo: bxpData?.logo || "",
      industry_id: bxpData?.industry_id || "",
      website_link: bxpData?.website_link || "",
      address: bxpData?.address || "",
      pincode: bxpData?.pincode || "",
      city: bxpData?.city || "",
      country_id: bxpData?.country_id || "",
      description: bxpData?.description || "",
      image: bxpData?.image || [],
      files: bxpData?.files || [],
    };
  }, [bxpData]);

  useEffect(() => {
    LoadCSSforfirstTime("Assets/scss/FirstTimeUsers.module.scss");
  }, []);


  console.log(bxpData, 'bxpDatabxpDatabxpData');

  useEffect(() => {
    dispatch(GetCountry());
    dispatch(getIndustry());
  }, [dispatch]);

  const handleSubmit = async (values) => {
    setLoading(true);
    let updatedData = { ...bxpData, ...values };

    try {
      if (logoImage) {
        const logoRef = ref(
          getStorage(fireStore),
          `/CompanyLogos/${logoImage.name}`
        );
        const logoUploadTask = uploadBytesResumable(logoRef, logoImage);
        await logoUploadTask;
        const logoURL = await getDownloadURL(logoUploadTask.snapshot.ref);
        updatedData.logo = logoURL;
      }

      if (profileImage) {
        const imageRef = ref(
          getStorage(fireStore),
          `/CompanyProfiles/${profileImage.name}`
        );
        const imageUploadTask = uploadBytesResumable(imageRef, profileImage);
        await imageUploadTask;
        const imageURL = await getDownloadURL(imageUploadTask.snapshot.ref);
        updatedData.image = imageURL;
      }
      setbxpData(updatedData);

      if (updateindex !== null) {
        dispatch(updateMerger(updatedData, setLoading));
      } else {
        dispatch(addMerger(updatedData, setLoading));
        localStorage.removeItem("MAS_DRAFT");
      }
      setModalOpen(false);
      setModal(false);
    } catch (error) {
      urtoast(error.message, 2);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (bxpData?.industry_id && industrylist?.length) {
      const selectedIndustry = industrylist.find((item) => item.id == bxpData?.industry_id);
      setSelectIndustry(selectedIndustry ? { value: selectedIndustry.id, label: selectedIndustry.title } : {
        value: bxpData.industry_id,
        label: bxpData.industry_title || "Select Industry",
      });
    }
  }, [bxpData, industrylist]);

  useEffect(() => {
    if (bxpData?.country_id && countrylist?.length) {
      const selectedCountry = countrylist.find((item) => item.id == bxpData?.country_id);
      setSelectCountry(selectedCountry ? { value: selectedCountry.id, label: selectedCountry.title } : {
        value: bxpData.country_id,
        label: bxpData.country_title || "Select Country",
      });
    }
  }, [bxpData, countrylist]);



  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize={updateindex !== null}
      >
        {(formik) => {
          return (
            <Form>
              <SyncParent
                values={formik.values}
                setbxpData={setbxpData}
                updateindex={updateindex}
                initialValues={initialValues}
                setChangesIsThere={setChangesIsThere}
              />
              <div>
                {bxpDatatomap.map((prop, key) => {
                  if (prop.name == "logo") {
                    return (
                      <div className="form-group  upload-item-images" key={key}>
                        <CoverImages
                          formik={formik}
                          doctype={1}
                          type={'single'}
                          name={prop.name}
                          title={prop.title}
                        />
                        <ul className="border-ul">
                          <li>Images (JPG, PNG, JPEG up to 10MB)</li>
                        </ul>
                      </div>
                    );
                  }
                  if (prop.name == "files") {
                    return (
                      <>
                        <div key={key} className="form-group down-top-btn-none">
                          <label>{prop.title} </label>
                          <CompanyFileUpload formik={formik} name={`files`} />
                          <ErrorMessage name={prop.name} component="div" className="error" />
                        </div>
                      </>
                    );
                  }
                  if (prop.name == "country_id") {
                    return (
                      <div className="form-group" key={key}>
                        <label>{prop.title}</label>
                        <ReactSelect
                          options={
                            Array.isArray(countrylist) &&
                            countrylist.map((country) => ({
                              value: country.id,
                              label: country.title,
                            }))
                          }
                          value={selectCountry}
                          placeholder={"Select Option"}
                          onChange={(option) => {
                            formik.setFieldValue(prop.name, option.value);
                            setSelectCountry(option);
                          }}
                        />
                        <ErrorMessage
                          name={prop.name}
                          component="div"
                          className="error"
                        />
                      </div>
                    );
                  }
                  if (prop.name == "industry_id") {
                    return (
                      <div className="form-group" key={key}>
                        <label>{prop.title}</label>
                        <ReactSelect
                          options={
                            Array.isArray(industrylist) &&
                            industrylist.map((industry) => ({
                              value: industry.id,
                              label: industry.title,
                            }))
                          }
                          value={selectIndustry}
                          placeholder={"Select Option"}
                          onChange={(option) => {
                            formik.setFieldValue(prop.name, option.value);
                            setSelectIndustry(option);
                          }}
                        />
                        <ErrorMessage
                          name={prop.name}
                          component="div"
                          className="error"
                        />
                      </div>
                    );
                  }
                  if (prop.name == "description") {
                    return (
                      <div className="form-group" key={key}>
                        <CustomReactQuill
                          value={formik.values.description}
                          formik={formik}
                          name={prop.name}
                          title={prop.title}
                        />
                        <ErrorMessage
                          name={prop.name}
                          component="div"
                          className="error"
                          style={{ color: "red" }}
                        />
                      </div>
                    );
                  }
                  return (
                    <FieldInput
                      title={prop.title}
                      name={prop.name}
                      placeholder={prop.placeholder}
                      key={key}
                    />
                  );
                })}
                <div className="button-container">
                  <button className="next-button w-100" type="submit">
                    {loading ? (
                      <LoginLoaderButton />
                    ) : (
                      `${updateindex !== null ? "Save" : "Add"
                      } Company and Publish`
                    )}
                  </button>
                </div>
              </div>
            </Form>
          )
        }}
      </Formik>
    </div>
  );
};

export default BXPDetails;
